module.exports = __webpack_public_path__ + "img/bobidu_bobocoin.gm.18007a1.png";